

























































































































import { QVueGlobals } from 'quasar';
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import LayerSelector from '@/components/LayerSelector.vue';
import EsriPopup from '@/components/EsriPopup.vue';
import EsriSearch from '@/components/EsriSearch.vue';
import EsriPrint from '@/components/EsriPrint.vue';
import EsriSketch from '@/components/EsriSketch.vue';
import Map from '@/views/Map.vue';
import Approvals from '@/components/Approvals.vue';
import AddData from '@/components/AddData.vue';
import About from '@/components/About.vue';
import LoginService from '../services/LoginService';
import Login from '../views/Login.vue';

@Component({
  components: {
      LayerSelector,
      EsriPopup,
      EsriSearch,
      EsriPrint,
      EsriSketch,
      Map,
      Approvals,
      AddData,
      About,
    },
})
export default class LayoutEditor extends Vue {

  get leftDrawerOpen() {
    return this.$store.state.leftDrawerOpen;
  }

  get rightDrawerOpen() {
    return this.$store.state.rightDrawerOpen;
  }

  get editLayer() {
    return this.$store.state.edit.layer;
  }

  get userRole() {
    return this.$store.state.user.role;
  }

  get unapprovedCount() {
    return this.$store.state.unapproved.count;
  }

  public unsubscribe = this.$store.subscribeAction((action, state) => {
      if (action.type === 'notify') {
          this.notify(action.payload);
      }
  });

  public notify(message: any) {
    this.$q.notify(message);
  }

  public mounted() {
    console.log('LayoutDefault: mounted()');
    return this.$store.state.isMobile = !this.$q.platform.is.desktop;
  }

  public created() {
    console.log('LayoutDefault: created()');
  }

  public onAbout() {
    this.$store.dispatch('aboutAction');
  }

  public drawerToggleLeft(content: string) {
    this.$store.dispatch('drawerToggleLeft', content);
  }

  public drawerToggleRight(content: string) {
    this.$store.dispatch('drawerToggleRight', content);
  }

  public sketchToggle() {
    this.$store.dispatch('sketchToggle');
  }

  public onRefreshToken() {
    this.$store.dispatch('refreshToken');
  }

  public onOpenPDF() {
    window.open('/PlaceNamesDigitalAtlasPDF.pdf');
  }

  public onLogout() {
    this.$store.dispatch('login', null);
    this.$router.push({name: 'login'});
  }
}
